<template>
  <div>
    <label class="font-weight-bold custom-legend-label"
      >Leyenda de Progreso</label
    >
    <div class="row">
      <div
        v-for="(item, key) in items"
        :key="key"
        class="col"
        :class="{
          'pl-2': key !== 0,
          'pr-0': key !== items.length - 1
        }"
      >
        <div class="py-1 mb-2" :style="{ backgroundColor: item.color }"></div>
        <p class="fs-13">{{ `${item.name}: ${item.description}` }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressLegend",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style scoped lang="scss">
.fs-13 {
  font-size: 13px;
}
.custom-legend-label {
  color: #5f777b;
}
</style>
